import script from "./CardFragmentsView.vue?vue&type=script&setup=true&lang=js"
export * from "./CardFragmentsView.vue?vue&type=script&setup=true&lang=js"

import "./CardFragmentsView.vue?vue&type=style&index=0&id=5755b38f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5755b38f"]])

export default __exports__